<script setup>
import EmailingForm from '@frontJs/components/forms/projectManagement/sem/EmailingForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, semEmailing } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: true,
    },
    semEmailing: {
        type: [Object, null],
        required: false,
        default: null,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="semEmailing">
            Mettre à jour l'emailing #{{ semEmailing.id }} - Emailings - SEM -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un emailing - Emailings - SEM - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle
        v-if="semEmailing"
        :tenant-name="tenant ? tenant.name : undefined"
    >
        Gestion de projet - Emailings - SEM - Mettre à jour l'emailing #{{
            semEmailing.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - Emailings - SEM - Créer un emailing
    </PageTitle>

    <EmailingForm
        :tenant="tenant"
        :website-variants="websiteVariants"
        :sem-emailing="semEmailing"
    />
</template>
